module.exports = __webpack_public_path__ + "media/images/share-1f7184f08e5d8c2d15dc8c4352a34e03.svg";